import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})

export class StorageService extends OAuthStorage {
  getItem(key: string): string {
    /*return this.cookieService.get(key);*/
    return window.sessionStorage.getItem(key) || '';
  }

  removeItem(key: string): void {
    /*this.cookieService.delete(key);*/
    window.sessionStorage.removeItem(key);
  }

  setItem(key: string, data: string): void {
    /*const now = new Date();
    now.setHours(now.getHours() + 8);
    this.cookieService.set(key, data, now, undefined, undefined, true, 'Lax');*/
    window.sessionStorage.setItem(key, data);
  }
}

